export default "__VITE_ASSET__xqT8OdLz__"